/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_V2_Conversion_PipelineInputs */

const en_settings_v2_conversion_pipeline = /** @type {(inputs: Settings_V2_Conversion_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion pipeline`)
};

const es_settings_v2_conversion_pipeline = /** @type {(inputs: Settings_V2_Conversion_PipelineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline de conversión`)
};

/**
* | output |
* | --- |
* | "Conversion pipeline" |
*
* @param {Settings_V2_Conversion_PipelineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_v2_conversion_pipeline = /** @type {((inputs?: Settings_V2_Conversion_PipelineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_V2_Conversion_PipelineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_v2_conversion_pipeline(inputs)
	return en_settings_v2_conversion_pipeline(inputs)
});